import { LOCAL_STORAGE } from '@/constants';
import { defaultBetasStorage } from './get-beta-status';

const updateBetas = (betas: string[]) => {
    localStorage.setItem(LOCAL_STORAGE.ENABLED_BETAS, JSON.stringify(betas));
};

const toggleBeta = (betaKey: string, enabled: boolean) => {
    const enabledBetas = localStorage.getItem(LOCAL_STORAGE.ENABLED_BETAS);
    if (enabledBetas) {
        let parsedBetaEnabled: string[] = [];
        try {
            parsedBetaEnabled = JSON.parse(enabledBetas);
        } catch (e) {
            // If parsing fails, reset to defaultBetasStorage
            updateBetas(defaultBetasStorage);
            parsedBetaEnabled = [...defaultBetasStorage];
        }

        if (Array.isArray(parsedBetaEnabled)) {
            if (!enabled) {
                const updatedBetas = parsedBetaEnabled.filter((beta: string) => beta !== betaKey);
                updateBetas(updatedBetas);
            } else {
                const updatedBetas = parsedBetaEnabled.includes(betaKey)
                    ? parsedBetaEnabled
                    : [...parsedBetaEnabled, betaKey];
                updateBetas(updatedBetas);
            }
        }
    } else {
        if (enabled) {
            updateBetas([...defaultBetasStorage, betaKey]);
        } else {
            updateBetas(defaultBetasStorage);
        }
    }
    window.dispatchEvent(new Event('beta-toggle'));
};
export default toggleBeta;
